import { isEmpty, isString, isArray } from 'lodash'

const state = {
  roles: [],
}

const getters = {
  matchRoles: state => (requiredRoles = []) => {
    if (isEmpty(requiredRoles)) {
      return true
    }

    if (isString(requiredRoles)) {
      return state.roles.includes(requiredRoles)
    }

    if (isArray(requiredRoles)) {
      return requiredRoles.every(requiredRole => {
        return state.roles.includes(requiredRole)
      })
    }

    // If it is object,
    // key should be the name of role
    // value should be the existence of the corresponding role
    return Object.entries(requiredRoles).every(([value, requiredRole]) => {
      return value === state.roles.includes(requiredRole)
    })
  }
}

const mutations = {
  SET_ROLES (state, roles) {
    state.roles = roles
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/acl.js